import classNames from 'classnames';

import { isFreeSpinsBundleItem, isMetaGameBundleItem, isSnappyGiftBundleItem } from '../../stores/rewards/helpers';
import type { BundleItem } from '../../stores/rewards/types';
import { FRBWidget } from '../FRBWidget/FRBWidget';
import { MetaGameWidget } from '../MetaGameWidget/MetaGameWidget';
import type { MetagameWidgetDirection } from '../MetaGameWidget/types';
import { SnappyGiftReward } from '../SnappyGiftReward/SnappyGiftReward';

import classes from './BundleItemsRenderer.module.scss';

type BundleItemsRendererProps = {
  bundleItems: BundleItem[];
  className?: string;
  metagameIconClassName?: string;
  metagameTextContainerClassName?: string;
  metagameTextClassName?: string;
  frbWidgetWidth?: number;
  metaGameWidgetWidth?: number;
  direction?: MetagameWidgetDirection;
  hidePlus?: boolean;
  dataTestId?: string;
  snappyGiftWidgetWidth?: number;
};

export function BundleItemsRenderer({
  bundleItems,
  className,
  metagameIconClassName,
  metagameTextContainerClassName,
  metagameTextClassName,
  frbWidgetWidth,
  metaGameWidgetWidth,
  snappyGiftWidgetWidth,
  direction,
  hidePlus,
  dataTestId,
}: BundleItemsRendererProps) {
  return (
    <div
      className={classNames(classes.bundleItemsRenderer, direction === 'vertical' && classes.vertical)}
      data-testid={dataTestId}
    >
      {bundleItems.map((item, index) => {
        const isLastItem = index === bundleItems.length - 1;

        return (
          <div key={index} className={classNames(classes.bundleItem, className)}>
            {isFreeSpinsBundleItem(item) && (
              <FRBWidget
                betAmount={item.bundlePayload.bet}
                coinType={item.bundlePayload.coinType}
                gameImage={item.bundlePayload.gameImageUrl}
                maxPrize={item.bundlePayload.maxPrize}
                provider={item.bundlePayload.provider}
                rounds={item.bundlePayload.rounds}
                type={item.bundlePayload.type}
                width={frbWidgetWidth}
              />
            )}
            {isMetaGameBundleItem(item) && (
              <MetaGameWidget
                amount={item.bundlePayload.amount}
                className={classes.metaGameWidget}
                coinType={item.bundlePayload.coinType}
                currencyName={item.bundlePayload.currencyName}
                currencySymbol={item.bundlePayload.currencySymbol}
                direction={direction || 'horizontal'}
                metagameIconClassName={metagameIconClassName}
                metagameTextClassName={metagameTextClassName}
                metagameTextContainerClassName={metagameTextContainerClassName}
                metagameTypeId={item.bundlePayload.metagameTypeId}
                width={metaGameWidgetWidth}
              />
            )}
            {isSnappyGiftBundleItem(item) && (
              <SnappyGiftReward snappyGiftPayload={item.bundlePayload} width={snappyGiftWidgetWidth} />
            )}
            {!isLastItem && !hidePlus && <div className={classes.plus}>+</div>}
          </div>
        );
      })}
    </div>
  );
}
